import React from 'react';
import { connect } from 'react-redux';
import { sendSocketEmit } from 'actions';
import { Container, Checkbox } from 'components';
import { Col, Row } from 'react-bootstrap';
import { saveEditedUser } from 'api';

class NotificationSettings extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tasks_desktop: false,
      tasks_mobile: false,
      tasks_email: false,
      other_desktop: false,
      other_mobile: false,
      other_email: false
    }

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(updated_setting) {
    const updated_state = { ...this.state, ...updated_setting };
    this.setState(updated_state);
    const { user } = this.props.users;
    const payload = {
      ...user,
      settings: {
        ...(user.settings || {}),
        notifications: updated_state
      }
    };
    this.props.sendSocketEmit(payload, 'edit-user');
  }
  componentWillMount() {
    const { user } = this.props.users;
    if(user.settings && user.settings.notifications) {
      this.setState({ ...this.state, ...user.settings.notifications });
    }
  }

  render() {
    return (
      <div className='notification-settings-container'>
        <section className='notification-settings-banner-container'>
          <Row>
            <Col md={12} xs={12}>
              <h3>Choose how you would like to receive notifications :</h3>
            </Col>
          </Row>
          <div className='notification-settings-banner-inner-container'>
            <Row>
              <Col md={4} xs={4}>
                <div className='desktop-opt-container banner-section-container'>
                  <Col xs={4} md={4}>
                    <i className='fa fa-desktop n-settings-banner-img' />
                  </Col>
                  <Col xs={8} md={8}>
                    <p>A banner displayed on your computer screen</p>
                  </Col>
                </div>
              </Col>
              <Col md={4} xs={4}>
                <div className='mobile-opt-container banner-section-container'>
                  <Col xs={4} md={4}>
                    <i className='fa fa-mobile n-settings-banner-img' />
                  </Col>
                  <Col xs={8} md={8}>
                    <p>A notification on your phone</p>
                  </Col>
                </div>
              </Col>
              <Col md={4} xs={4}>
                <div className='desktop-opt-container banner-section-container'>
                  <Col xs={4} md={4}>
                    <i className='fa fa-envelope-o n-settings-banner-img' />
                  </Col>
                  <Col xs={8} md={8}>
                    <p>An email sent to your inbox</p>
                  </Col>
                </div>
              </Col>
            </Row>
          </div>
        </section>
        <section>
          <Row>
            <Col md={6} xs={6}>
              Task reminder notifications:
            </Col>
            <Col md={2} xs={2}>
              <Checkbox
                name='desktop'
                label='Desktop'
                checked={this.state.tasks_desktop}
                onChange={() => this.handleChange({ tasks_desktop: !this.state.tasks_desktop })}
              />
            </Col>
            <Col md={2} xs={2}>
              <Checkbox
                name='mobile'
                label='Mobile'
                checked={this.state.tasks_mobile}
                onChange={() => this.handleChange({ tasks_mobile: !this.state.tasks_mobile })}
              />
            </Col>
            <Col md={2} xs={2}>
              <Checkbox
                name='email'
                label='Email'
                checked={this.state.tasks_email}
                onChange={() => this.handleChange({ tasks_email: !this.state.tasks_email })}
              />
            </Col>
          </Row>
          <hr className='short'/>
          <Row>
            <Col md={6} xs={6}>
              Other notifications:
            </Col>
            <Col md={2} xs={2}>
              <Checkbox
                name='desktop'
                label='Desktop'
                checked={this.state.other_desktop}
                onChange={() => this.handleChange({ other_desktop: !this.state.other_desktop })}
              />
            </Col>
            <Col md={2} xs={2}>
              <Checkbox
                name='mobile'
                label='Mobile'
                checked={this.state.other_mobile}
                onChange={() => this.handleChange({ other_mobile: !this.state.other_mobile })}
              />
            </Col>
              <Col md={2} xs={2}>
              <Checkbox
                name='email'
                label='Email'
                checked={this.state.other_email}
                onChange={() => this.handleChange({ other_email: !this.state.other_email })}
              />
            </Col>
          </Row>
          <hr className='short'/>
        </section>
      </div>
    );
  }
}

const mapStateToProps = ({ users }) => ({ users });

export default connect(mapStateToProps, { sendSocketEmit })(NotificationSettings);



// WEBPACK FOOTER //
// ./src/browser/components/settings/notifications/notification-settings.js